<template>
  <div class="fullview">
    <div class="loading-spacer"></div>
    <vue-loading
        type="bubbles"
        color="#4cb433"
        :size="{ width: '100px', height: '100px' }"
    >
    </vue-loading>
  </div>
</template>

<script>
  import { VueLoading } from 'vue-loading-template'

  export default {
    components: {
      VueLoading
    }
  }
</script>
